webpackJsonp([263791100135453],{

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 40em;\n'], ['\n  max-width: 40em;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: #32F095;\n  font-weight: normal;\n'], ['\n  color: #32F095;\n  font-weight: normal;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = _styledComponents2.default.section(_templateObject);
	
	var Bolder = _styledComponents2.default.b(_templateObject2);
	
	var About = function About() {
	  return _react2.default.createElement(
	    Section,
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Theology + Technology'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Faith Leads Tech is a one day, single track conference bringing together followers of Jesus Christ who seek to utilize technology and innovation to provide biblical solutions for life.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Attendees from varying backgrounds -',
	      ' ',
	      _react2.default.createElement(
	        Bolder,
	        null,
	        'Developers, Designers, Marketers, Product Visionaries, Ministry Tech Leaders'
	      ),
	      ' ',
	      '- will gain insights and perspectives from technology experts and ministry tech leaders on current innovations at a global, church, university and individual level. Keynotes and talks will explore a wide range of opportunities that currently exist at the intersection of Faith and Technology, as well as what innovations will be needed to provide effective technology for the church of tomorrow.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For ',
	      _react2.default.createElement(
	        Bolder,
	        null,
	        'Technologists'
	      ),
	      ', this gathering will offer encouragement, showing that we as believers are not alone in our faith or efforts and offer support for being a strong believer in today\u2019s technical environment.'
	    ),
	    ' ',
	    _react2.default.createElement(
	      'p',
	      null,
	      'For ',
	      _react2.default.createElement(
	        Bolder,
	        null,
	        'Ministry Tech Leaders'
	      ),
	      ', the conference will provide an opportunity to learn of current innovations in ministry tech, share pain points that may be solved through technology, and network with other ministry tech leaders who are seeking to spread the gospel and grow the church with the help of technology.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Throughout the day there will be opportunities for conversation with enterprises/companies, ministries, startups and individuals actively pursuing innovative technologies in ministry.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Outcomes of the event will range from learning of',
	      ' ',
	      _react2.default.createElement(
	        Bolder,
	        null,
	        'shared struggles and successes'
	      ),
	      ',',
	      ' ',
	      _react2.default.createElement(
	        Bolder,
	        null,
	        'aligning'
	      ),
	      ' of ministries around',
	      ' ',
	      _react2.default.createElement(
	        Bolder,
	        null,
	        'common goals'
	      ),
	      ', and',
	      ' ',
	      _react2.default.createElement(
	        Bolder,
	        null,
	        'awareness'
	      ),
	      ' of innovative uses of technologies for',
	      ' ',
	      _react2.default.createElement(
	        Bolder,
	        null,
	        'Kingdom impact'
	      ),
	      '. Ultimately, it will',
	      ' ',
	      _react2.default.createElement(
	        Bolder,
	        null,
	        'build community between followers of Jesus Christ'
	      ),
	      ' ',
	      'interested in furthering His Kingdom through',
	      ' ',
	      _react2.default.createElement(
	        Bolder,
	        null,
	        'Technology and Innovation.'
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _about = __webpack_require__(222);
	
	var _about2 = _interopRequireDefault(_about);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(_about2.default, null);
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-84534352832320a6ea8c.js